export const FILTER_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  DATE: 'date',
  DATE_TIME: 'dateTime',
  SET: 'set',
  BOOLEAN: 'boolean',
} as const

export const GRID_TEMPLATE_SORT_FILTER =
  '<div class="ag-cell-label-container grid-custom-header" role="presentation">' +
  '  <div data-ref="eLabel" class="ag-header-cell-label" role="presentation">' +
  '    <div data-ref="eText" class="ag-header-cell-text" role="columnheader"></div>' +
  '    <div class="wrapSort">' +
  '      <span data-ref="eSortAsc" class="grid-header-icon ag-header-asc"></span>' +
  '      <span data-ref="eSortDesc" class="grid-header-icon ag-header-desc"></span>' +
  '      <span data-ref="eSortNone" class="grid-header-icon ag-header-asc-desc"></span>' +
  '    </div>' +
  '  </div>' +
  '  <span data-ref="eMenu" class="grid-header-icon ag-header-filter-menu"></span>' +
  '  <span data-ref="eFilterButton" class="grid-header-icon filter-icon"></span>' +
  '</div>'

export const DEFAULT_ROW_HEIGHT = 56
